import type { Prototype } from "../prototype-types";

export const pauloPintoPrototypes: Prototype[] = [
  {
    id: "pp-rg-f-30-d-xp-impact-calendar",
    name: "H2 2025 RG XP Impact Calendar",
    path: "/pp/rg-f-30-d-xp-impact-calendar",
    description:
      "H2 2025 RG XP impact calendar: all 245 XPs, 3% material threshold (funnel + F30D GMV global)",
    owner: "Paulo Pinto",
    createdAt: "2026-06-05",
    lastUpdated: "2026-06-08",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.faire.com/fastly/6dff498bfe9a6aedbfd14302fce009561965b59da100b5ab379c8e8cb0f28feb.png",
    creationTool: "claude-code",
  },
];
